import React from 'react';
import { Box } from '@mui/material';
import ReCAPTCHA from 'react-google-recaptcha';
import PlrModal from '../../../landing/PlrModal';
import { plr } from '../../../landing/tokens';

type RecaptchaDialogProps = {
  open: boolean;
  siteKey: string;
  onClose: () => void;
  // Se llama con el token apenas la persona pasa el reCAPTCHA: ahí se envía el RUT.
  onVerified: (token: string) => void;
  onCheck?: () => void;
};

// 1f: el reCAPTCHA v2 sale de la pantalla y se pide en un diálogo al tocar "Ver si califico"
// (hoja inferior en mobile, diálogo centrado en desktop, como el resto del flujo).
export default function RecaptchaDialog({
  open, siteKey, onClose, onVerified, onCheck,
}: RecaptchaDialogProps) {
  const recaptchaRef = React.useRef<ReCAPTCHA>(null);
  const [errored, setErrored] = React.useState(false);

  React.useEffect(() => {
    if (open) setErrored(false);
  }, [open]);

  const handleChange = (token: string | null) => {
    if (!token) return;
    if (onCheck) onCheck();
    onVerified(token);
  };

  const handleErrored = () => {
    setErrored(true);
    recaptchaRef.current?.reset();
  };

  return (
    <PlrModal
      open={open}
      onClose={onClose}
      title="Confirma que no eres un robot"
      titleId="preloan-captcha-title"
      testId="preloan-captcha-dialog"
      // El desafío de imágenes de Google se abre fuera del diálogo: el foco tiene que poder ir ahí.
      disableEnforceFocus
    >
      <Box
        component="p"
        sx={{
          m: '-6px 0 0', fontSize: { xs: 13.5, sm: 14 }, lineHeight: 1.45, color: plr.body,
        }}
      >
        Es un paso de seguridad. Al marcar la casilla revisamos si calificas.
      </Box>
      {/* El widget mide 304 x 78 px; se reserva el alto para que la hoja no salte al cargar. */}
      <Box sx={{
        display: 'flex', justifyContent: 'center', minHeight: 78, my: '4px',
      }}
      >
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={siteKey}
          onChange={handleChange}
          onErrored={handleErrored}
        />
      </Box>
      {errored && (
        <Box
          component="p"
          role="alert"
          sx={{
            m: '-6px 0 0', fontSize: 13, color: '#C0392B', textAlign: 'center',
          }}
        >
          No pudimos verificar. Intenta de nuevo.
        </Box>
      )}
    </PlrModal>
  );
}

RecaptchaDialog.defaultProps = {
  onCheck: undefined,
};
